<div class="loginContainer">
  <div class="innerContainer">
    <img class="wifilogo" [src]="imagePath" />
    <br />
    <div style="margin-top:173px;padding-left:13%;" *ngIf="isAuthroized!=='false'">
      <span class="onlineNotification">You have been logged out</span>
      <br />
      <button type="button" class="loginbtn" (click)="loginAgain()" name="button" [disabled]="!online">Login again</button>
    </div>
    <div style="margin-top:173px;padding-left:10%;" *ngIf="isAuthroized==='false'">
      <span class="onlineNotification">You are not an authorized user.</span>
    </div>
  </div>
</div>
